import type { Transaction } from './finance.ts';
import type { FinanceCategory } from './categories.ts';
import { calculateProfitLoss,createFinancialResolver,type CategoryFinancialMapping,type FinancialAccount } from './profit-loss.ts';

export function previewCategoryAccountMapping(rows:Transaction[],accounts:FinancialAccount[],categories:FinanceCategory[],mappings:CategoryFinancialMapping[],category:string,next:CategoryFinancialMapping|null){
  const nextMappings=[...mappings.filter((m)=>m.category!==category),...(next?[next]:[])];
  const before=createFinancialResolver(accounts,[],mappings,categories),after=createFinancialResolver(accounts,[],nextMappings,categories);
  const seen=new Set<string>();
  const affected=rows.filter((r)=>{
    if(r.deletedAt||!r.direction||seen.has(r.id))return false;
    seen.add(r.id);return r.category===category||r.subcategory===category;
  }).map((row)=>{
    const a=before(row),b=after(row);
    const signature=(v:typeof a)=>JSON.stringify([v.account?.slug,v.account?.section,v.account?.active,v.source,v.reason,v.mappingCategory]);
    return {row,before:a,after:b,protected:a.source==='manual'||a.source==='legacy',changed:signature(a)!==signature(b)};
  });
  return {nextMappings,affected,before:calculateProfitLoss(rows,accounts,[],mappings,categories),after:calculateProfitLoss(rows,accounts,[],nextMappings,categories)};
}
